import styled from "styled-components";

type Props = {
  type?: string;
};

const EmailTrendsLoader = function (props: Props) {
  const { type } = props;
  return (
    <>
      <Wrapper>
        <div className="sk-container">
          <div className="d-flex flex-column mb-2">
            <span className="skeleton-box digit-box"></span>
            <span className="skeleton-box text-box"></span>
          </div>
          <div className="chart-loader d-flex align-items-center mb-2">
            <span className={`skeleton-box ${type === "clickchart" ? "click-bar" : "email-bar"} `}></span>
          </div>
        </div>
      </Wrapper>
    </>
  );
};

export default EmailTrendsLoader;

const Wrapper = styled.div`
  overflow: hidden;
  @-webkit-keyframes shimmer {
    100% {
      -webkit-transform: translateX(100%);
      transform: translateX(100%);
    }
  }

  @keyframes shimmer {
    100% {
      -webkit-transform: translateX(100%);
      transform: translateX(100%);
    }
  }
  .sk-container {
    width: 100%;
    background-color: #ffffff;
    padding: 0px;
    margin: 0;
    display: flex;
    align-items: center;
    .skeleton-box {
      display: inline-block;
      height: 1em;
      position: relative;
      overflow: hidden;
      background-color: #e9e9e9;
      &.digit-box {
        height: 18px;
        width: 110px;
        border-radius: 8px;
      }
      &.text-box {
        height: 10px;
        width: 81px;
        margin-top: 2px;
        border-radius: 8px;
      }
      &.email-bar {
        width: 100%;
        height: 35px;
        border-radius: 8px;
      }
      &.click-bar {
        height: 35px;
        width: 100%;
        border-radius: 8px;
      }
      &:after {
        position: absolute;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        -webkit-transform: translateX(-100%);
        transform: translateX(-100%);
        background-image: -webkit-gradient(
          linear,
          left top,
          right top,
          color-stop(0, rgba(255, 255, 255, 0)),
          color-stop(20%, rgba(255, 255, 255, 0.2)),
          color-stop(60%, rgba(255, 255, 255, 0.5)),
          to(rgba(255, 255, 255, 0))
        );
        background-image: linear-gradient(
          90deg,
          rgba(255, 255, 255, 0) 0,
          rgba(255, 255, 255, 0.2) 20%,
          rgba(255, 255, 255, 0.5) 60%,
          rgba(255, 255, 255, 0)
        );
        -webkit-animation: shimmer 2s infinite;
        animation: shimmer 2s infinite;
        content: "";
      }
    }
    .chart-loader {
      width: 100%;
      margin-left: 50px;
      margin-right: 10px;
      @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
        margin-left: 100px;
      }
    }
  }
`;
